import { gql } from '@parkchirp/api-client';

export const SYNC_RESERVATION_IN_ACCESS_SYSTEM = gql`
  mutation syncReservationInAccessSystem($sessionId: Int!, $facilityId: String!) {
    syncReservationInAccessSystem(sessionId: $sessionId, facilityId: $facilityId)
  }
`;
